import { action } from '@ember/object';
import Component from '@glimmer/component';

interface IArgs {
  definition: TFilterDefinition;
  values: string[];
  multiple: boolean;
  onChange?: (values: string[]) => void;
}
export default class SelectFilter extends Component<IArgs> {
  get selected() {
    const { definition, values = [], multiple } = this.args;
    if (multiple) {
      return values.map((v) => {
        return definition.possibleValues?.findBy('key', v);
      });
    } else {
      if (values.length > 0) {
        return definition.possibleValues?.findBy('key', values[0]);
      } else {
        return undefined;
      }
    }
  }

  @action
  valuesDidChange(values: TSelectOption[]) {
    this.args.onChange?.(values.map((v) => v.key));
  }

  @action
  singleValueDidChange(value?: TSelectOption) {
    this.args.onChange?.(value ? [value.key] : []);
  }
}
